export const runWithClientDeadline = ({
  createRequest,
  timeoutMs = 15_000,
  timeoutMessage = "Request timed out. Please try again.",
} = {}) => {
  if (typeof createRequest !== "function") {
    return Promise.reject(new TypeError("createRequest must be a function"));
  }
  const controller =
    typeof AbortController !== "undefined" ? new AbortController() : null;
  let timeoutId = null;
  const timeoutPromise = new Promise((_resolve, reject) => {
    timeoutId = setTimeout(() => {
      controller?.abort();
      const error = new Error(timeoutMessage);
      error.name = "TimeoutError";
      error.code = "client-request-timeout";
      reject(error);
    }, Math.max(1, Number(timeoutMs) || 15_000));
  });
  const request = Promise.resolve().then(() =>
    createRequest({ signal: controller?.signal }),
  );
  return Promise.race([request, timeoutPromise]).finally(() => {
    if (timeoutId) clearTimeout(timeoutId);
  });
};
